import {
  LoadingTypes,
  startLoading,
  stopLoading,
  errorLogger,
} from '@labrav/common'
import { camelize } from 'casing'
import { IntegrationValue } from './reducer'
import { fetchThirdPartyAppList } from '../../common/api/notificationAPI'
import { RootState, AppDispatch } from '../../store/types'

export enum IntegrationsType {
  SET_INTEGRATIONS = 'SET_INTEGRATIONS',
}

export const getThirdPartyAppList =
  (partnerId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    try {
      dispatch(startLoading(LoadingTypes.GENERAL))
      const { data } = await fetchThirdPartyAppList(partnerId)
      dispatch(setIntegrations(camelize(data.integrations)))
    } catch (err: unknown) {
      const globalState = getState()
      errorLogger({ globalState })(err as Error)
    } finally {
      dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const setIntegrations = (
  integrationsObj: Record<string, IntegrationValue>
) => ({
  type: IntegrationsType.SET_INTEGRATIONS,
  payload: { integrationsObj: camelize(integrationsObj) },
})
